import React, { useContext, useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import { Header, NavLinks, CCListOrders } from "../common"
import { Route, Routes, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import CCOrderDetailContent from "./click-collect-detail"
import { OrderContext } from '../../context/orders';


const authUser = () => {
  const user = localStorage.getItem("isLoggedIn");
  return user;
};

const employeeExists = () => {
  const employeeid = localStorage.getItem("employeeid");
  return employeeid;
}

function ClickAndCollectOrders() {

  let isAuthUser = authUser();
  let isEmployeeExist = employeeExists();
  const [ordersData, setOrdersData] = React.useState([]);
  const [pagination, setPagination] = React.useState({});
  const navigate = useNavigate();
  const currLocation = useLocation();
const currPath = currLocation.pathname.replace("/", "");

  let {storeId, setStoreId} = useContext(OrderContext);
  const [loading, setLoading] = useState(true);
  const [itemsPerPage] = useState(100);
  const clickCollectOrder = 'cc';
      useEffect(() => {
        setTimeout(() => {
          setLoading(false);
        }, 3000);
      }, []);
  const fetchData = async () => {
  setLoading(true);
  let finalStoreId = storeId || localStorage.getItem("storeid");
  if (finalStoreId && !storeId) {
    setStoreId(finalStoreId);
  }

  try {
    const apiUrl = `${process.env.REACT_APP_STORE_URL}/ccOrders/cclist`;
    const response = await axios.post(apiUrl, {
      storeId: finalStoreId,
      itemsPerPage,
      clickCollectOrder
    });

    if (response.data.orders) {
      setOrdersData(response.data.orders);
      setPagination(response.data.pagination);
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  } finally {
    setLoading(false);
  }
};

  console.log('API response:', ordersData);
  
  React.useEffect(() => {
    console.log(ordersData.length)
    isAuthUser ? navigate("/click-collect") : navigate("/");
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthUser, isEmployeeExist]);

  return (
    <Row className="allorder m-0">
      <Header />
      {loading ? <div className="loader">
      <div className="spinner"></div>
      </div>  : ''}
      <Row className="flex-wrap mainsection">
        <div className="col-md-2 row-cols-12 left-panel p-0">
          <NavLinks/>
        </div>
        <div className="col-md-10 align-items-center row-cols-12 p-0">
          <h2 className="h2 p-4 m-0">CLICK AND COLLECT COMMANDES</h2>
            <Routes>
              {ordersData.length > 0 && (
                <Route
                  path="/click-collect"
                  element={<CCListOrders ordersData={ordersData} pagination={pagination} />}
                />
              )}
              <Route
                path="/cc-order-detail/:orderId"
                element={<CCOrderDetailContent />}
              />
            </Routes>
        </div>
      </Row>
    </Row>
  );
}

export default ClickAndCollectOrders;